export default "__VITE_ASSET__CKNn50b2__";